import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UploadDurcDocument } from '../../models/durc'

const { API_URL } = environment;

@Injectable({
  providedIn: 'root'
})
export class DurcService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  async getDurcFolder(token: any): Promise<any> {
    try {
      const httpHeaders = new HttpHeaders({ Authorization: `Bearer ${token}` });
      return this.httpClient.get<any>(`${API_URL}/durc`, { headers: httpHeaders }).toPromise();
    } catch (err) {
      console.log('>>> err', err);
    }
  }

  async sendDurcDocument(token: any, durc: UploadDurcDocument): Promise<any> {
    try {
      const httpHeaders = new HttpHeaders({ Authorization: `Bearer ${token}` });
      return this.httpClient.post<any>(`${API_URL}/durc`, durc, { headers: httpHeaders }).toPromise();
    } catch (err) {
      console.log('>>> err', err);
    }
  }

}
